import { c as _c } from "react/compiler-runtime";
import { IcoFootprint16, LogoIcoVerified } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
export const PoweredByVerifiedAndFootprint = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectData.confirm"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span>{t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LogoIcoVerified />;
    t4 = <span>+</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="flex items-center gap-1 text-label-3 text-primary"><IcoFootprint16 />Footprint</span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2) {
    t6 = <p className="text-body-3 text-tertiary flex items-center gap-1.5 justify-center flex-wrap">{t2}{t3}{t4}{t5}</p>;
    $[8] = t2;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
function _temp($) {
  return $.poweredBy;
}